
import React from 'react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Link } from 'react-router-dom';
import { Heart, ChevronUp, ChevronDown } from 'lucide-react';
import { triggerLisaChat } from '@/utils/onboarding/onboardingEvents';

interface LisaAdviceBoxProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

const LisaAdviceBox: React.FC<LisaAdviceBoxProps> = ({ isOpen, onOpenChange }) => {
  const handleLisaAvatarClick = () => {
    triggerLisaChat();
  };

  return (
    <div className="mb-6">
      <Collapsible open={isOpen} onOpenChange={onOpenChange}>
        <div className="bg-gradient-to-br from-purple-100/50 to-purple-50 backdrop-blur-sm border border-purple-200 rounded-lg shadow-sm px-4 py-4">
          <div className="flex justify-between items-start">
            <div className="flex flex-col sm:flex-row items-center sm:items-start gap-3">
              <div className="flex-shrink-0 text-center sm:text-left">
                <Avatar 
                  className="h-12 w-12 border-2 border-vegana-primary cursor-pointer"
                  onClick={handleLisaAvatarClick}
                >
                  <AvatarImage src="/lovable-uploads/ae745547-332f-46cf-8369-8992e8b453d4.png" alt="Lisa" />
                  <AvatarFallback>L</AvatarFallback>
                </Avatar>
              </div>
              <CollapsibleContent>
                <p className="text-sm leading-tight text-gray-600">
                  Holi, haz clic en el botón 'Generar Menú Completo' para que yo te genere automáticamente un menú adaptado a tus características y objetivos. Si no te gusta alguna receta la puedes sustituir por otra de la sección de 'Recetas'. Si quieres actualizar tus características puedes ir <Link to="/nutricion" className="text-green-600 font-medium hover:underline">aquí</Link>. Y, si quieres algún consejito estoy disponible en el chat <Heart className="inline h-4 w-4 text-red-500" />
                </p>
              </CollapsibleContent>
            </div>
            <CollapsibleTrigger asChild>
              <button className="p-1 hover:bg-purple-100 rounded-full">
                {isOpen ? <ChevronUp className="h-4 w-4 text-purple-500" /> : <ChevronDown className="h-4 w-4 text-purple-500" />}
              </button>
            </CollapsibleTrigger>
          </div>
        </div>
      </Collapsible>
    </div>
  );
};

export default LisaAdviceBox;
